import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class DocumentsInformationForm extends AppForm {
  constructor() {
    super({
      description: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      })
    });
  }
}
